// Core Imports
import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";

// Bootstrap Components
import { Container, Col, Row } from "react-bootstrap";

// Assets and Icons
import Logo from "../assets/images/logo/logo-light-r.png";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";
import RoomIcon from "@mui/icons-material/Room";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";

const Footer = () => {
  const location = useLocation().pathname;

  // State for mobile menu highlighting
  const [activePage, setActivePage] = useState({
    home: "",
    services: "",
    contact: "",
  });

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    updateActivePage(location);
    // eslint-disable-next-line
  }, []);

  // Updates active link state and scrolls to top
  const updateActivePage = (path) => {
    setActivePage({
      home: path === "/" ? "active" : "",
      services: path === "/services" ? "active" : "",
      contact: path === "/contact-us" ? "active" : "",
    });
    window.scrollTo(0, 0);
  };

  return (
    <div id="footer">
      <Container>
        <Row className="justify-content-lg-between justify-content-center">
          {/* Logo and Social Icons */}
          <Col className="col-12 col-sm-12 col-md-4 col-lg-3 d-flex align-items-center justify-content-center mb-4 mb-md-0">
            <img src={Logo} alt="SADP Logo" className="img-fluid mb-3" />
            {/* <div className="social">
              <ul className="list-unstyled d-flex justify-content-center">
                <li className="mx-2">
                  <Link to="#!"><InstagramIcon /></Link>
                </li>
                <li className="mx-2">
                  <Link to="#!"><FacebookIcon /></Link>
                </li>
                <li className="mx-2">
                  <Link to="#!"><YouTubeIcon /></Link>
                </li>
                <li className="mx-2">
                  <Link to="#!"><TwitterIcon /></Link>
                </li>
              </ul>
            </div> */}
          </Col>

          {/* Quick Links Section */}
          <Col className="col-12 col-sm-12 col-md-4 col-lg-2 mb-4 mb-md-0 px-xl-5">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><h6><a href="/">Home</a></h6></li>
              <li><h6><a href="/about-us">About Us</a></h6></li>
              <li><h6><a href="/services">Services</a></h6></li>
              <li><h6><a href="/gallery">Gallery</a></h6></li>
              <li><h6><a href="/contact-us">Contact Us</a></h6></li>
            </ul>
          </Col>

          {/* Contact Details */}
          <Col className="col-12 col-sm-12 col-md-4 col-lg-3 px-xl-5">
            <h5>Contact Us</h5>
            <RoomIcon />
            <p>186 Milford Road<br />Te Anau 9600<br />New Zealand</p>
            <LocalPhoneIcon />
            <p><a href="tel:+64 03/660 4888">+64 03/660 4888</a></p>
            <EmailIcon />
            <p><a href="mailto:office@southernalpsdp.co.nz">office@southernalpsdp.co.nz</a></p>
          </Col>

          {/* Embedded Google Map */}
          <Col className="col-12 col-sm-12 col-md-5 col-lg-3">
            <h5>Google Map</h5>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2800.799433749425!2d167.71765667704435!3d-45.413383905319684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa9d40e4a6f698b33%3A0x33720336da945834!2s186%20Milford%20Road%2C%20Te%20Anau%209600!5e0!3m2!1sen!2snz!4v1770677593732!5m2!1sen!2snz"
              width="100%"
              height="150"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              title="SADP Map Location"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Col>
        </Row>

        {/* Divider */}
        <hr />

        {/* Footer Bottom Row */}
        <Row>
          <Col md={8} className="copyright">
            <p>&copy; {currentYear} Southern Alps Development Projects Ltd. All rights reserved.</p>
          </Col>
          <Col md={4} className="copyright links">
            <p>
              <a href="/privacy-policy">Privacy Policy</a> |{" "}
              <a href="/sitemap">Sitemap</a>
            </p>
          </Col>
        </Row>
      </Container>

      {/* Mobile Footer Menu */}
      <div className="d-block d-md-none menu-footer">
        <Row className="p-3">
          <Col className="b-right">
            <Link to="/" className={activePage.home} onClick={() => updateActivePage("/")}>
              Home
            </Link>
          </Col>
          <Col className="b-right">
            <Link to="/services" className={activePage.services} onClick={() => updateActivePage("/services")}>
              Services
            </Link>
          </Col>
          <Col>
            <Link to="/contact-us" className={activePage.contact} onClick={() => updateActivePage("/contact-us")}>
              Contact Us
            </Link>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Footer;
